import gql from 'graphql-tag';

export const approveProfilePictureMutation = gql`
  mutation approveProfilePicture($approvalId: String!) {
    approveProfilePicture(approvalId: $approvalId)
  }
`;
